import { render, staticRenderFns } from "./DownloadableTemplate.vue?vue&type=template&id=1a81b5ea&"
import script from "./DownloadableTemplate.vue?vue&type=script&lang=js&"
export * from "./DownloadableTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports